import { request } from "../network/request";
const db = "dn0";

export function getreviewerList(params) {
    return request({
        url: "pmp/reviewer/list",
        method: "post",
        data: params,
    });
}

export function deleteReviewer(id) {
    return request({
        url: "pmp/reviewer/deleteReviewer",
        method: "get",
        params: {
            id
        }
    });
}

export function getJdlxSelector() {
    return request({
        url: "pmp/reviewer/getJdlxSelector",
        method: "get",
    });
}
/**
 * 新增/编辑审核人
 * @returns 
 */
export function saveReviewer(params) {
    return request({
        url: "pmp/reviewer/saveReviewer",
        method: "post",
        data: params
    });
}
export function getReviewerById(params) {
    return request({
        url: "pmp/reviewer/getReviewerById",
        method: "get",
        params
    });
}

